module.exports = __webpack_public_path__ + "images/free-size-icon.a6938f2dacf17c59d34614dcf485ac32.png";